import React from "react";

export default function IonIcon({ name, className = "", style = {} }) {
  return <ion-icon name={name} className={className} style={style} />;
}
